export default __webpack_public_path__ + "static/proxima-nova-900-0b61ebba714ae70563fc714c383ab617.woff";